(function () {
    'use strict';

    function main() {
        var searchController = {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            init: function () {}
        };

        searchController.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
